// extracted by mini-css-extract-plugin
export default {"ReactQuillDisplay":"ReactQuillDisplay_ReactQuillDisplay__MA1iF","click-zoom":"ReactQuillDisplay_click-zoom__2pc-b"};